var HeaderCharmType;
(function (HeaderCharmType) {
    HeaderCharmType[HeaderCharmType["FeedbackCharm"] = 0] = "FeedbackCharm";
    HeaderCharmType[HeaderCharmType["FeatureFlagsCharm"] = 1] = "FeatureFlagsCharm";
    HeaderCharmType[HeaderCharmType["HelpCharm"] = 2] = "HelpCharm";
    HeaderCharmType[HeaderCharmType["PersonaCharm"] = 3] = "PersonaCharm";
    HeaderCharmType[HeaderCharmType["SettingsCharm"] = 4] = "SettingsCharm";
    HeaderCharmType[HeaderCharmType["WaffleCharm"] = 5] = "WaffleCharm";
    HeaderCharmType[HeaderCharmType["DiagnosticsCharm"] = 6] = "DiagnosticsCharm";
    HeaderCharmType[HeaderCharmType["GetStartedCharm"] = 7] = "GetStartedCharm";
    HeaderCharmType[HeaderCharmType["WhatsNewCharm"] = 8] = "WhatsNewCharm";
    HeaderCharmType[HeaderCharmType["TodoCharm"] = 9] = "TodoCharm";
})(HeaderCharmType || (HeaderCharmType = {}));
export default HeaderCharmType;
//# sourceMappingURL=HeaderCharmType.js.map